import { WorkorderField } from "src/app/core/models/workorder.model";
import { OrdersToEmployeeField } from "src/app/core/models/orders-to-employee.model";

/**
 * Shared field arrays for workflow module
 * These fields are used across multiple components/services for API queries
 *
 * CENTRALIZED MANAGEMENT: Update here once instead of 4+ locations
 */

/**
 * Standard workorder fields for workflow views
 * Includes all necessary fields for displaying and managing workorders
 */
export const WORKFLOW_WORKORDER_FIELDS: WorkorderField[] = [
	WorkorderField.OrderId,
	WorkorderField.CreatedBy,
	WorkorderField.OwnerId,
	WorkorderField.OrderNumber,
	WorkorderField.Description,
	WorkorderField.OrderDate,
	WorkorderField.IsPasserBy,
	WorkorderField.PlanningStartDate,
	WorkorderField.PlanningReadyDate,
	WorkorderField.VehicleId,
	WorkorderField.ContactId,
	WorkorderField.IsVehicleHere,
	WorkorderField.ContactsVDisplayName,
	WorkorderField.ContactFullName,
	WorkorderField.VehicleDisplayName,
	WorkorderField.VehicleLicensePlate,
	WorkorderField.IsUnknownVehicle,
	WorkorderField.OrderType,
	WorkorderField.OrderLicensePlate,
	WorkorderField.OrderDescriptionId,
	WorkorderField.WorkflowStatusId,
	WorkorderField.EmployeeId,
	WorkorderField.EmployeeIdAssignedTo,
	WorkorderField.isCustomDescription,
	WorkorderField.RmOrderToEmployeesEmployeeId,
	WorkorderField.RmTimesheetsEmployeeId,
	WorkorderField.RmTimesheetsEndTime,
	WorkorderField.RmTimesheetsStartTime,
	WorkorderField.RmTimesheetsTimesheetId,
	WorkorderField.RmTimesheetsHourTypeId,
	WorkorderField.InvoiceDate,
	WorkorderField.IsInvoiced,
	WorkorderField.InvoiceNumber,
	WorkorderField.IsCiPrinted,
	WorkorderField.IsCollect
];

/**
 * Standard orders-to-employee fields for workflow views
 * Used to fetch employee assignments for workorders
 */
export const WORKFLOW_ORDERS_TO_EMPLOYEE_FIELDS: OrdersToEmployeeField[] = [
	OrdersToEmployeeField.EmployeeId,
	OrdersToEmployeeField.OdersToEmployeeId,
	OrdersToEmployeeField.OrderId
];
